import { IonSkeletonText } from '@ionic/react'
import React, { FC } from 'react'
import EventCardSkeleton from './EventCardSkeleton'

interface EventsSkeletonProps {
	display: boolean
}

const EventsSkeleton: FC<EventsSkeletonProps> = ({ display }) => {
	if (!display) return null

	return (
		<div className='flex flex-col gap-2 bg-white dark:bg-[#0d2d30] border border-[#c4c4c4] dark:border-[#144448] rounded-xl p-3'>
			<IonSkeletonText animated className='w-20' />
			<EventCardSkeleton />
			<EventCardSkeleton />
			<IonSkeletonText animated className='w-full h-px' />
			<IonSkeletonText animated className='w-20' />
			<EventCardSkeleton />
		</div>
	)
}

export default EventsSkeleton
